import * as types from './types'

let initialStatuses = {
	loading: false,
	failed: false,
	data: null,
	success: false
}

export const initialStaffingPosition = {
	code: '',
	externalId: '',
	factSalary: '',
	freelance: false,
	grossSalary: '',
	salarySupplement: '',
	staffFreeCount: '',
	staffUnitsCount: '',
	errors: [],
	isReplacement: false,
	isCombining: false,
	isDicPosition: '2',
}

export const initialStaffingGroup = {
	destablishedPost: '',
	dposition: '',
	dstaffCategory: '',
	factSalary: '',
	grossSalary: '',
	orgId: '',
	salarySupplement: '',
	workplaceCount: '',
	structureId: '',
	isDicPosition: '2',
	errors: [],
	workPlaces: [initialStaffingPosition],
}

export const initialStaffing = {
	id: 1,
	parentId: null,
	orderNumber: '',
	orderDate: '',
	cause: '',
	tariffRate: null,
	units: [
		{
			subsidiary: false,
			binBranch: '',
			deptTypeCode: '',
			dept: {
				nameKz: '',
				nameRu: '',
				code: '',
			},
		},
	],
}

export const initialStaff = {
	actual: false,
	beginDate: '',
	bin: '',
	childs: [
		{
			binBranch: '',
			childs: [{}],
			dept: {
				code: '',
				nameKz: '',
				nameRu: '',
			},
			deptTypeCode: '',
			externalId: '',
			parentExternalId: '',
			positionGroups: [initialStaffingGroup],
			errors: [],
		},
	],
	currVersion: 0,
	externalId: '',
	note: '',
	orderDate: '',
	orderNumber: '',
	parentBin: '',
	statusCode: '',
	errors: [],
}

const initialState = {
	isLoading: false,
	isSuccess: false,
	error: null,
	staff: {
		data: initialStaff,
		isLoading: false,
		isSuccess: false,
	},
	openedChildsIds: [],
	staffXML: null,

	positionByDeptType: initialStatuses,
	staffExperience: initialStatuses,
	staffUnit: initialStatuses,
	staffLevel: initialStatuses,

	dictCategory: initialStatuses,
	dictEstablishedPost: initialStatuses,
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.TOGGLE_LOADING:
			return { ...state, isLoading: payload }
		case types.TOGGLE_SUCCESS:
			return { ...state, isSuccess: payload }
		case types.TOGGLE_ERROR:
			return { ...state, error: payload }
		case types.SET_STAFF_PROJECT:
			return {
				...state,
				staff: {
					...state.staff, // сохраняем все остальные свойства staff без изменений
					data: payload, // обновляем data новыми данными
				},
			}
		case types.ADD_OPENED_CHILD_ID:
			return {
				...state,
				openedChildsIds: [...state.openedChildsIds, payload],
			}
		case types.REMOVE_OPENED_CHILD_ID:
			return {
				...state,
				openedChildsIds: state.openedChildsIds.filter((id) => id !== payload),
			}
		case types.SET_STAFF_XML:
			return { ...state, staffXML: payload }
		case types.SET_STATUS:
			return {
				...state,
				staff: {
					...state.staff,
					data: {
						...state.staff.data,
						statusCode: payload,
					},
				},
			}

		case types.GET_POSITION_DEPT_TYPE:
			return { ...state, positionByDeptType: { ...initialStatuses, loading: true } }

		case types.GET_POSITION_DEPT_TYPE_DONE:
			return { ...state, positionByDeptType: { ...initialStatuses, data: payload, success: true } }

		case types.GET_POSITION_DEPT_TYPE_FAIL:
			return { ...state, positionByDeptType: { ...initialStatuses, failed: true } }


		case types.GET_STAFF_EXPERIENCE:
			return { ...state, staffExperience: { ...initialStatuses, loading: true } }

		case types.GET_STAFF_EXPERIENCE_DONE:
			return { ...state, staffExperience: { ...initialStatuses, data: payload, success: true } }

		case types.GET_STAFF_EXPERIENCE_FAIL:
			return { ...state, staffExperience: { ...initialStatuses, failed: true } }


		case types.GET_STAFF_UNIT:
			return { ...state, staffUnit: { ...initialStatuses, loading: true } }

		case types.GET_STAFF_UNIT_DONE:
			return { ...state, staffUnit: { ...initialStatuses, data: payload, success: true } }

		case types.GET_STAFF_UNIT_FAIL:
			return { ...state, staffUnit: { ...initialStatuses, failed: true } }


		case types.GET_STAFF_LEVEL:
			return { ...state, staffLevel: { ...initialStatuses, loading: true } }

		case types.GET_STAFF_LEVEL_DONE:
			return { ...state, staffLevel: { ...initialStatuses, data: payload, success: true } }

		case types.GET_STAFF_LEVEL_FAIL:
			return { ...state, staffLevel: { ...initialStatuses, failed: true } }


		case types.GET_STAFF_CATEGORY:
			return { ...state, dictCategory: { ...initialStatuses, loading: true } }

		case types.GET_STAFF_CATEGORY_DONE:
			return { ...state, dictCategory: { ...initialStatuses, data: payload, success: true } }

		case types.GET_STAFF_CATEGORY_FAIL:
			return { ...state, dictCategory: { ...initialStatuses, failed: true } }


		case types.GET_ESTABLISHED_POST_BY_CATEGORY_CODE:
			return { ...state, dictEstablishedPost: { ...initialStatuses, loading: true } }

		case types.GET_ESTABLISHED_POST_BY_CATEGORY_CODE_DONE:
			return { ...state, dictEstablishedPost: { ...initialStatuses, data: payload, success: true } }

		case types.GET_ESTABLISHED_POST_BY_CATEGORY_CODE_FAIL:
			return { ...state, dictEstablishedPost: { ...initialStatuses, failed: true } }

		case types.SET_OPENED_CHILD_IDS:
			return {
				...state,
				openedChildsIds: payload,
			}


		default:
			return state
	}
}
